var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "base-settings-page-sidebar",
    {
      attrs: {
        title: _vm.title,
        "actions-type": _vm.actionsType,
        "success-button-state": _vm.successButtonState,
        "cancel-button-state": _vm.cancelButtonState,
        "delete-button-state": _vm.deleteButtonState,
      },
      on: {
        create: function ($event) {
          return _vm.onSuccess("create")
        },
        update: function ($event) {
          return _vm.onSuccess("update")
        },
        cancel: function ($event) {
          return _vm.$emit("cancel")
        },
        delete: _vm.onDelete,
      },
    },
    [
      _c("agent-status-item-settings", {
        attrs: { item: _vm.item, errors: _vm.errors },
        on: { "item-change": _vm.onItemChange },
      }),
      _vm._v(" "),
      _c(
        "or-confirm",
        {
          ref: "confirm",
          attrs: {
            "title-text": _vm.$t(
              "hitl.settings.agent-status.confirm-delete-status"
            ),
            "confirm-type": "d",
          },
          on: { confirm: _vm.onConfirmDelete },
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.$t("hitl.settings.agent-status.confirm-delete-description")
              ) +
              "\n  "
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }